// new file
import type { FC } from "react";

import styles from "./FlavorFinderStepper.module.scss";

type FlavorFinderStepperProps = {
  currentStep: number;
  totalSteps: number;
  ariaLabel?: string;
};

export const FlavorFinderStepper: FC<FlavorFinderStepperProps> = ({
  currentStep,
  totalSteps,
  ariaLabel = "Flavor finder progress",
}) => {
  const safeTotal = Math.max(1, totalSteps);
  const safeCurrent = Math.min(safeTotal, Math.max(0, currentStep));
  const progressPercent = `${(safeCurrent / safeTotal) * 100}%`;

  return (
    <div
      className={styles.stepper}
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={safeTotal}
      aria-valuenow={safeCurrent}
    >
      <div className={styles.track}>
        <div className={styles.fill} style={{ width: progressPercent }} />
      </div>
    </div>
  );
};
